/* eslint-disable consistent-return */
import { Button, Grid } from '@material-ui/core';
import { postStudentSoftware } from '@webapps/business';
import {
  FormikAutocomplete,
  FormikAutocompletePx,
  FormikTextField,
  useAuth,
  useMutation,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Row from 'components/Form/Row';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import * as yup from 'yup';

const langSchema = yup.object().shape({
  label: yup.string().required('Requis'),
  level: yup.number().required('Requis'),
});

export const LEVEL = [
  {
    value: 1,
    label: 'Débutant',
  },
  {
    value: 2,
    label: 'Intermédiaire',
  },
  {
    value: 3,
    label: 'Avancé',
  },
  {
    value: 4,
    label: 'Confirmé',
  },
];

const AddSoftware = ({ close, refetch }) => {
  const { css } = useStyles();

  const { idUser } = useAuth();

  const {
    isLoading,
    isSuccess,
    mutateAsync: mutateSoftware,
  } = useMutation(postStudentSoftware);

  const { addToast } = useToast();

  useEffect(() => {
    if (isSuccess) {
      addToast({
        status: 'success',
        message: 'Opération réussie',
      });
      close();
      refetch();
    }
  }, [isSuccess]);

  const formik = useFormik({
    initialValues: {
      label: '',
      level: '',
    },
    validationSchema: langSchema,
    onSubmit: async (values) => {
      await mutateSoftware({
        data: values,
        id: idUser,
      });
    },
  });

  return (
    <div>
      <Row>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              fullWidth
              borderRadius={6}
              inputProps={{ maxLength: 50 }}
              label="Intitulé du logiciel"
              name="label"
            />
          </Grid>
          <Grid item xs={12}>
            <FormikAutocompletePx
              defaultValue=""
              formik={formik}
              fullWidth
              borderRadius={6}
              getOptionLabel={(option) => option.label || ''}
              getOptionSelected={(option, value) =>
                value.value === option.value
              }
              label={<FormattedMessage id="vitrine.level" />}
              name="level"
              options={LEVEL}
              pathValue="value"
              value={
                LEVEL.find(({ value }) => value === formik.values.level) || null
              }
            />
          </Grid>
        </Grid>
      </Row>
      <Row>
        <Grid container spacing={2}>
          <Grid className={css({ textAlign: 'center' })} item xs>
            <Button
              className={css({ borderRadius: '400px' })}
              color="primary"
              disabled={isLoading}
              onClick={formik.handleSubmit}
              variant="contained"
            >
              <FormattedMessage id="vitrine.btnCreate" />
            </Button>
          </Grid>
        </Grid>
      </Row>
    </div>
  );
};

AddSoftware.propTypes = {
  refetch: PropTypes.func,
  close: PropTypes.func,
};

export default AddSoftware;
